import { useIntl } from 'react-intl';

import UserSelect from '~/components/Shared/UserSelect/UserSelect';
import { useAppConfigContext } from '~/contexts/AppConfig';
import { FormField } from '~/eds/src/components/FormField/FormField';
import { PilotId } from '~/eds/src/types/PilotId';
import { Nullable } from '~/types/Nullable';

import { UserCustomSettings } from '../types/fields';
import { WorkflowQuestionFormField } from './types';

export const UserWorkflowQuestion = ({
  question,
  onChange,
  ...rest
}: WorkflowQuestionFormField<Nullable<PilotId[]>>) => {
  const intl = useIntl();
  const { isPanelEnlarged } = useAppConfigContext();
  const {
    field: { customSettings, value },
  } = question;
  const {
    users,
    rule,
    allow_multiple: allowMultiple,
  } = customSettings as UserCustomSettings;

  return (
    <FormField
      {...rest}
      input={UserSelect}
      placeholder={
        allowMultiple
          ? intl.formatMessage({
              id: 'UserWorkflowQuestion.selectMultipleUsersPlaceholder',
              defaultMessage: 'Specify one or more users...',
              description:
                'Placeholder for selecting multiple users in an intake form question',
            })
          : intl.formatMessage({
              id: 'UserWorkflowQuestion.selectSingleUserPlaceholder',
              defaultMessage: 'Specify a user...',
              description:
                'Placeholder for selecting a single user in an intake form question',
            })
      }
      value={value.value}
      onChange={(value) => onChange(value, 'value')}
      inputProps={{
        enablePortal: true,
        notAvailableUsers: rule === 'all_except' ? users : undefined,
        specificUsers: rule === 'specific' ? users : undefined,
        isMulti: allowMultiple,
        width: isPanelEnlarged ? 'input.l.width' : '100%',
      }}
    />
  );
};
